import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconRefresh.tsx
const IconRefresh = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M4.553 3.695a8.333 8.333 0 0 1 12.272 11.09L14.167 10h2.5a6.667 6.667 0 0 0-11.283-4.81zm10.895 12.612A8.333 8.333 0 0 1 3.176 5.217l2.658 4.784h-2.5a6.666 6.666 0 0 0 11.283 4.81z"
	})]
});
var IconRefresh_default = forwardRef(IconRefresh);
//#endregion
export { IconRefresh_default as default };
